import EditIcon from "@mui/icons-material/Edit";
import LogoutIcon from "@mui/icons-material/Logout";
import HomeIcon from "@mui/icons-material/Home";
import QrCodeIcon from "@mui/icons-material/QrCode";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
} from "@mui/material";
import { RoutePaths } from "constants/RoutePaths";
import { MyTrainingsViewContext } from "context/myTrainings/MyTrainingsViewContext";
import { useLogout } from "hooks/useLogout";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const StyledDrawer = styled(Drawer)({
  "& .MuiDrawer-paper": {
    width: 260,
    height: "fit-content",
    marginTop: 10,
    marginRight: 10,
    borderTopRightRadius: 8,
    borderTopLeftRadius: 8,
    borderBottomRightRadius: 8,
    borderBottomLeftRadius: 8,
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
  },
});

const StyledList = styled(List)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
}));

const LogoutListItemText = styled(ListItemText)(({ theme }) => ({
  "& .MuiListItemText-primary": {
    color: theme.palette.error.main,
  },
}));

type Props = {
  open: boolean;
  onClose: () => void;
};

export const MobileMenuComponent = ({ open, onClose }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const logout = useLogout();
  const { user, isStatisticOfLoggedUser } = useContext(MyTrainingsViewContext);

  const handleEditProfileClick = () => {
    onClose();
    navigate(
      isStatisticOfLoggedUser
        ? RoutePaths.PROFILE
        : `${RoutePaths.PROFILE}?userId=${user?.id}`,
    );
  };

  const handleQrClick = () => {
    onClose();
    navigate(RoutePaths.HOME_QR);
  };

  const handleHomeClick = () => {
    onClose();
    navigate(RoutePaths.HOME);
  };

  const handleLogoutClick = async () => {
    onClose();
    await logout();
    navigate(RoutePaths.LOGIN);
  };

  return (
    <StyledDrawer anchor="right" open={open} onClose={onClose}>
      <StyledList>
        <StyledListItemButton onClick={handleHomeClick}>
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary={t("mobileMenu.home")} />
        </StyledListItemButton>

        <StyledListItemButton onClick={handleEditProfileClick}>
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          <ListItemText primary={t("myTrainings.editProfile")} />
        </StyledListItemButton>

        <StyledListItemButton onClick={handleQrClick}>
          <ListItemIcon>
            <QrCodeIcon />
          </ListItemIcon>
          <ListItemText primary={t("mobileMenu.loginToVrWithQr")} />
        </StyledListItemButton>

        <StyledListItemButton onClick={handleLogoutClick}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <LogoutListItemText primary={t("navbar.logout")} />
        </StyledListItemButton>
      </StyledList>
    </StyledDrawer>
  );
};
